import { render } from "./Pontaj.vue?vue&type=template&id=70139fb9&ts=true"
import script from "./Pontaj.vue?vue&type=script&lang=ts"
export * from "./Pontaj.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__